import React from "react";

export default function RIGHT() {
  return <div>Excel_RIGHT</div>;
}
